<template>
    <!--排序题-->
    <div @click="setEditIndex(index)">
		<p v-if="isBankViewTest" class="my-bank-tag">{{$t('main.SortQuestion')}}</p>
        <el-row :gutter="10" class="question-box">
            <el-col v-if="!isBankViewTest" :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">
                {{ question.quesIndex + 1 }}
            </el-col>
            <el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" class="item_container_title"
                @click="setActiveInput(question.qid)">
               
                <span style="lineHeight: 30px" v-if="isBankViewTest && question.questionsName">{{question.questionsName}}</span>
				 <TitleEditor 
                    :isTest="true"
					v-if="!isBankViewTest"
					class="outline-none" 
					:qid="question.qid" 
					:class="question.qid"  
					:value="question.questionsName" 
                    :actionTitleEditorShow="activeInputId === question.qid"
					@childValueChange="val=>{ question.questionsName = val }" 
				></TitleEditor>
            </el-col>
			<el-col class="setBtn-box" :xs="7" :sm="7" :md="7" :lg="7" :xl="7" v-if="!$route.query.index">
				<OperateWrap
					style="display: flex;
						width: 100%;
						justify-content: end;
					"
					:bankId="$route.query.bankId"	
					:question="question"
				></OperateWrap>
			</el-col>
        </el-row>
        <el-row :gutter="10" style="margin-top: 12px !important;" >

            <div @click="setEditOptionIndex(childindex)" v-for="(childItem,childindex) in question.optionList"
                :key="index+'_'+childindex">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"
                        class="el_item_option item_container_title" style="margin-left:50px">
                    <div class="el-dropdown-link dropdown">
                        <i class="el-icon-sort" style="color:#9f9f9f"></i>
                        <div style="width: 70%;" @click="setActiveInput(childItem.oid)">
                            <span v-if="isBankViewTest">{{childItem.labelName}}</span>
                            <TitleEditor
                                class="outline-none" 
                                :qid="childItem.oid" 
                                :class="childItem.oid"  
                                :value="childItem.labelName" 
                                :actionTitleEditorShow="activeInputId === childItem.oid"
                                @childValueChange="(val) => labelNameChange(val, childItem)" 
                            ></TitleEditor>
                        </div>
                        <div 
                            v-if="childItem.haveInput"
                            class="other-input">
                            <el-input
                                disabled
                                size="mini"
                                v-model="value"
                                >
                            </el-input>
                        </div>
                        <i class="el-icon-remove el-icon-common-option" v-if="editOptionIndex==index+'_'+childindex"
                        @click="wjdelquestionoption(childItem.oid)"></i>
                    </div>
                </el-col>
            </div>

        </el-row>
        <el-row  :gutter="10" style="margin-top: 12px !important;" v-if="question.isedit && !isBankViewTest">
            <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16"
                    class="el_item_option item_container_title" style="margin-left:50px">
                <i
                    class="el-icon-plus el-icon-common"
                    @click="wjaddquestionoption()"
                >{{$t('main.AddOptions')}}</i>
                <i
                    class="el-icon-s-fold el-icon-common"
                    @click="$refs.batchAdd.batchAddshow = true"
                >{{$t('main.BatchAdd')}}</i>
                <i
                    class="el-icon-menu el-icon-common"
                    @click="addOther"
                >{{$t('main.AddOther')}}</i>
            </el-col>
        </el-row>
        <BatchAddOption 
			ref="batchAdd"
			:title="$t('main.option')" 
			:functionName="'batchAdd'"
            :question="question"
			@batchAdd="batchAdd"
		/>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import OperateWrap from "./collectToBank/operateaWrap.vue"
import TitleEditor from "@/components/titleEditor/titleEditor.vue"
import BatchAddOption from "@/components/myComponents/batchAddOption/batchAddOption.vue"
    export default {
        components: {
            TitleEditor,
		    BatchAddOption,
            OperateWrap
        },
        data() {
            return {
                isdialogshow:false,
                optionBatch: '',
                value: '',
            }
        },
        props: {
            question: {},
            editIndex: {type:Number,default:0},
            index: {type:Number,default:0},
            isExistPage: {type:Boolean,default:false},
            editOptionIndex: {type:String,default:"0_0"},
            // 管理题库时查看试题 只可以删除
            isBankViewTest: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            ...mapState(['activeInputId']),
        },
        methods: {
            ...mapActions(['setActiveInput']),
            labelNameChange(val, option) {
                option.labelName = val
            },
            wjaddquestionoption() {
                this.$emit("wjaddquestionoption", this.question.qid, [this.$t('main.NewOptions')], this.question.questionsTypeId);
            }, 
            addOther(){
                this.$emit("wjaddquestionoption", this.question.qid, [this.$t('main.other')], this.question.questionsTypeId, true)
            },
            batchAdd(optionArr) {
                this.$emit("wjaddquestionoption", this.question.qid, optionArr, this.question.questionsTypeId);
            },
			handleBatchAdd(options,item){
				this.$emit("batchAdd", options, item);
			},
            setEditIndex(index){
                this.$emit("setEditIndex",index);
            },
            setEditOptionIndex(childIndex){
                this.$emit("setEditOptionIndex",childIndex)
            },
            wjdelquestionoption(oid){
                this.$emit("wjdelquestionoption", { qid: this.question.qid, oid });
            },
        },
        created() {

        }
    }
</script>

<style scoped lang="scss">
    .dropdown{
    //    float:left;   
        width: 100%;  
       height:40px;
       line-height:40px;
       display:flex;
       align-items: center;
    }
    /* .dropdown i{
        float:left;
    }
    .dropdown el-input{
        float:left;
    } */
.item .el-badge__content.is-fixed{top:10px;}
.item.drag-handle{
  cursor: move;
}
    .el_item_option {
        line-height: 40px;
        // height: 44px;
        float:left;
    }

    .el-icon-common {
        margin-right: 23px;
        font-size: 16px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }

    .el-icon-common-option {
        margin-left: 10px;
        font-size: 22px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }

    .askxh {
	line-height: 30px;
        text-align: right;
    }

    .item_container_title {
        padding-left: 15px !important;
        padding-right: 0px !important;
    }

/deep/.el-textarea .el-textarea__inner {
    border: 1px solid #DCDFE6 !important;
    background-color: #FFF;
}
.outline-none{
  /* display: inline-block; */
  outline: none;
//   max-width: 73%;
}
.other-input{
    width: 80px;
    margin-left: 10px;
    
}
.other-input /deep/.el-input--mini .el-input__inner{
  height: 22px;
  line-height: 22px;
}
</style>
